export { StyledText } from './loyalty-text-widget.styled.base';
